"use client"
import {
  Paper,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Box,
  Button,
  useTheme,
  alpha,
} from "@mui/material"
import {
  Person as PersonIcon,
  CreditCard as CreditCardIcon,
  Subscriptions as SubscriptionsIcon,
  MoreHoriz as MoreIcon,
} from "@mui/icons-material"

const RecentActivity = () => {
  const theme = useTheme()

  // Mock activity data
  const activities = [
    {
      id: 1,
      type: "user",
      message: "John Doe signed up",
      time: "2 hours ago",
      icon: <PersonIcon />,
      color: theme.palette.primary.main,
    },
    {
      id: 2,
      type: "credit",
      message: "Credits added to Acme Inc.",
      time: "5 hours ago",
      icon: <CreditCardIcon />,
      color: theme.palette.success.main,
    },
    {
      id: 3,
      type: "subscription",
      message: "New subscription from XYZ Corp",
      time: "1 day ago",
      icon: <SubscriptionsIcon />,
      color: theme.palette.secondary.main,
    },
    {
      id: 4,
      type: "user",
      message: "Jane Smith updated profile",
      time: "2 days ago",
      icon: <PersonIcon />,
      color: theme.palette.primary.main,
    },
  ]

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 2,
        height: "100%",
        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Recent Activity
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <List sx={{ px: 0 }}>
        {activities.map((activity) => (
          <ListItem
            key={activity.id}
            alignItems="flex-start"
            sx={{
              px: 0,
              "&:not(:last-child)": {
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
              },
            }}
          >
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: alpha(activity.color, 0.1), color: activity.color }}>{activity.icon}</Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={activity.message}
              secondary={activity.time}
              primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
              secondaryTypographyProps={{ variant: "caption" }}
            />
          </ListItem>
        ))}
      </List>

      <Box sx={{ mt: 2, textAlign: "center" }}>
        <Button endIcon={<MoreIcon />} sx={{ color: theme.palette.text.secondary }}>
          View All Activity
        </Button>
      </Box>
    </Paper>
  )
}

export default RecentActivity

